import { useEffect, useState } from "react";
import { toast } from "sonner";
import { teacherApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Database, Download, Trash2, AlertTriangle, Shield, Wrench, Gift, Sparkles, FileSearch, ArrowLeft, History, Mail, RefreshCw, TrendingUp, Eye, MessageSquareWarning, Check, Archive, MessageCircleReply, Send, X, Plus } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LineChart, Line, PieChart, Pie, Cell } from "recharts";
import { Link } from "react-router-dom";
import { Section, KpiTile, SCOPE_LABELS } from "./_shared";

// =========================== TRIAL ===========================
function TrialTab() {
  const [email, setEmail] = useState("");
  const [scope, setScope] = useState("all");
  const [days, setDays] = useState(14);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!email.trim()) { toast.error("Podaj e-mail nauczyciela"); return; }
    setBusy(true);
    try {
      const { data } = await teacherApi.post("/admin/grant-trial", {
        teacher_email: email.trim(), scope, days: Number(days), note: note || null,
      });
      toast.success(`Trial nadany do ${new Date(data.trial_ends_at).toLocaleDateString("pl")}`);
      setEmail(""); setNote("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Błąd nadawania trialu");
    } finally { setBusy(false); }
  };

  return (
    <Section icon={Gift} title="Nadaj darmowy trial">
      <div className="space-y-4 max-w-xl">
        <div>
          <Label className="font-bold">E-mail nauczyciela</Label>
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="nauczyciel@szkola.pl"
            className="mt-2 brut-input border-2 border-[#0F172A] rounded-md h-11"
            data-testid="trial-email-input"
          />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="font-bold">Zakres</Label>
            <Select value={scope} onValueChange={setScope}>
              <SelectTrigger className="mt-2 brut border-2 border-[#0F172A] rounded-md h-11 font-bold" data-testid="trial-scope-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="brut bg-white border-2 border-[#0F172A] rounded-md">
                <SelectItem value="all">Wszystkie 7 zakresów</SelectItem>
                {Object.entries(SCOPE_LABELS).map(([k, v]) => (
                  <SelectItem key={k} value={k}>{v}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="font-bold">Liczba dni</Label>
            <Input
              type="number" min={1} max={365} value={days}
              onChange={(e) => setDays(e.target.value)}
              className="mt-2 brut-input border-2 border-[#0F172A] rounded-md h-11"
              data-testid="trial-days-input"
            />
          </div>
        </div>
        <div>
          <Label className="font-bold">Notatka (opcjonalna)</Label>
          <Input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="np. zwycięzca konkursu, beta tester..."
            className="mt-2 brut-input border-2 border-[#0F172A] rounded-md h-11"
            data-testid="trial-note-input"
          />
        </div>
        <Button
          onClick={submit}
          disabled={busy}
          className="brut brut-hover bg-[#FEF08A] text-[#0F172A] font-bold rounded-md"
          data-testid="trial-submit-btn"
        >
          <Gift className="w-4 h-4 mr-2" strokeWidth={2.5} />Nadaj trial
        </Button>
      </div>
    </Section>
  );
}


export default TrialTab;
